import React, {Fragment, useContext} from "react";
import {buyNowContext} from "../BuyNow";
import {PORTALS, PRODUCT_CATEGORIES, PURCHASE_FLOWS} from "../../../../constants";
import LinkOrderToUser from "./LinkOrderToUser";

const ConfirmationMessage = () => {
  const { lineItems, shippingStageState, portal, purchaseFlow, order, deferredUserCreate } = useContext(buyNowContext);

  const planLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.MEMBERSHIP);
  const adminAccessLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.ADMIN_ACCESS);
  const scaleLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.SCALE);
  const scaleExists = !!scaleLineItem;
  const adminAccessExists = !!adminAccessLineItem;
  const planExists = !!planLineItem;

  const shapaMessage = (
    <div className="offset-2 col-8 offset-lg-2 col-lg-6">
      <p className="text-dark header-txt">Thank you for your order</p>

      <div className="next-button-txt text-muted">
        We've emailed you the order confirmation details.
      </div>

      {scaleExists &&
        <p className="next-button-txt text-muted">
          {`Your order will arrive within ${shippingStageState.shippingMethod.timeFrame}.`}
        </p>
      }

      {purchaseFlow !== PURCHASE_FLOWS.SHAPA_BP_ADDON && purchaseFlow !== PURCHASE_FLOWS.CLEARSTEP_BP_ADDON &&
        <p className="next-button-txt text-muted mb-lg-4">
          In order to use Shapa, you’ll need an account. Start personalizing your program while waiting for your Shapa!
        </p>
      }
    </div>
  );

  const generalMessage = (
    <div className="offset-2 col-8 offset-lg-2 col-lg-6">
      <p className="text-dark header-txt">Thank you for your order</p>

      {/* If an existing clinician made a membership-only purchase (ex. site license), let's ask to link to their existing account. */}
      {!adminAccessExists && planExists &&
        (
          purchaseFlow === PURCHASE_FLOWS.CLEARSTEP_CLINICIAN ||
          purchaseFlow === PURCHASE_FLOWS.SHAPA_HEALTH_CLINICIAN
        ) &&
        <Fragment>
          <LinkOrderToUser orderConfirmationToken={order.confirmationToken} />
          <br/>
        </Fragment>
      }

      <div className="next-button-txt text-muted">
        We've emailed you the order confirmation details.
      </div>

      {scaleExists &&
        <div className="next-button-txt text-muted">
          {`Your order will arrive within ${shippingStageState.shippingMethod.timeFrame}.`}
        </div>
      }
    </div>
  );

  const generalMessageBehalfOrgOwner = (
    <div className="offset-2 col-8 offset-lg-2 col-lg-6">
      <p className="text-dark header-txt">Thank you for your order!</p>
      <p className="text-dark header-txt">Important information has been emailed to {shippingStageState.email}.</p>
      <div className="next-button-txt text-muted">
        They have been emailed order confirmation details, and an email with a link to proceed with account creation.
      </div>
    </div>
  );

  if (portal === PORTALS.SHAPA)
    return shapaMessage;
  else {
    if (deferredUserCreate)
      return generalMessageBehalfOrgOwner;

    return generalMessage;
  }
};

export default ConfirmationMessage;